export default __webpack_public_path__ + "static/media/SEN-LIGHT-MOTION.f3731052.png";